export const KEYWORD_LIST = [
  '口コミ',
  '工事実績',
  'ガルバリウム',
  '助成金',
  'リフォーム',
  '評判が良い',
  'トタン',
  'リフォームローン',
  '火災保険',
  'アフターフォロー',
  'ベランダ防水',
  '油性塗料・水性塗料',
  'カラーシミュレーション',
  '耐久性',
  '防音',
];
